{
  "@algolia/abtesting@1.14.1": {
    "licenses": "MIT",
    "repository": "https://github.com/algolia/algoliasearch-client-javascript",
    "publisher": "Algolia",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@algolia/abtesting",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@algolia/abtesting/LICENSE"
  },
  "@algolia/client-abtesting@5.48.1": {
    "licenses": "MIT",
    "repository": "https://github.com/algolia/algoliasearch-client-javascript",
    "publisher": "Algolia",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@algolia/client-abtesting",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@algolia/client-abtesting/LICENSE"
  },
  "@algolia/client-analytics@5.48.1": {
    "licenses": "MIT",
    "repository": "https://github.com/algolia/algoliasearch-client-javascript",
    "publisher": "Algolia",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@algolia/client-analytics",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@algolia/client-analytics/LICENSE"
  },
  "@algolia/client-common@5.48.1": {
    "licenses": "MIT",
    "repository": "https://github.com/algolia/algoliasearch-client-javascript",
    "publisher": "Algolia",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@algolia/client-common",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@algolia/client-common/LICENSE"
  },
  "@algolia/client-insights@5.48.1": {
    "licenses": "MIT",
    "repository": "https://github.com/algolia/algoliasearch-client-javascript",
    "publisher": "Algolia",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@algolia/client-insights",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@algolia/client-insights/LICENSE"
  },
  "@algolia/client-personalization@5.48.1": {
    "licenses": "MIT",
    "repository": "https://github.com/algolia/algoliasearch-client-javascript",
    "publisher": "Algolia",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@algolia/client-personalization",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@algolia/client-personalization/LICENSE"
  },
  "@algolia/client-query-suggestions@5.48.1": {
    "licenses": "MIT",
    "repository": "https://github.com/algolia/algoliasearch-client-javascript",
    "publisher": "Algolia",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@algolia/client-query-suggestions",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@algolia/client-query-suggestions/LICENSE"
  },
  "@algolia/client-search@5.48.1": {
    "licenses": "MIT",
    "repository": "https://github.com/algolia/algoliasearch-client-javascript",
    "publisher": "Algolia",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@algolia/client-search",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@algolia/client-search/LICENSE"
  },
  "@algolia/ingestion@1.48.1": {
    "licenses": "MIT",
    "repository": "https://github.com/algolia/algoliasearch-client-javascript",
    "publisher": "Algolia",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@algolia/ingestion",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@algolia/ingestion/LICENSE"
  },
  "@algolia/monitoring@1.48.1": {
    "licenses": "MIT",
    "repository": "https://github.com/algolia/algoliasearch-client-javascript",
    "publisher": "Algolia",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@algolia/monitoring",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@algolia/monitoring/LICENSE"
  },
  "@algolia/recommend@5.48.1": {
    "licenses": "MIT",
    "repository": "https://github.com/algolia/algoliasearch-client-javascript",
    "publisher": "Algolia",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@algolia/recommend",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@algolia/recommend/LICENSE"
  },
  "@algolia/requester-browser-xhr@5.48.1": {
    "licenses": "MIT",
    "repository": "https://github.com/algolia/algoliasearch-client-javascript",
    "publisher": "Algolia",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@algolia/requester-browser-xhr",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@algolia/requester-browser-xhr/LICENSE"
  },
  "@algolia/requester-fetch@5.48.1": {
    "licenses": "MIT",
    "repository": "https://github.com/algolia/algoliasearch-client-javascript",
    "publisher": "Algolia",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@algolia/requester-fetch",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@algolia/requester-fetch/LICENSE"
  },
  "@algolia/requester-node-http@5.48.1": {
    "licenses": "MIT",
    "repository": "https://github.com/algolia/algoliasearch-client-javascript",
    "publisher": "Algolia",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@algolia/requester-node-http",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@algolia/requester-node-http/LICENSE"
  },
  "@angular-devkit/architect@0.2102.2": {
    "licenses": "MIT",
    "repository": "https://github.com/angular/angular-cli",
    "publisher": "Angular Authors",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@angular-devkit/architect",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@angular-devkit/architect/LICENSE"
  },
  "@angular-devkit/core@21.2.2": {
    "licenses": "MIT",
    "repository": "https://github.com/angular/angular-cli",
    "publisher": "Angular Authors",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@angular-devkit/core",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@angular-devkit/core/LICENSE"
  },
  "@angular-devkit/schematics@21.2.2": {
    "licenses": "MIT",
    "repository": "https://github.com/angular/angular-cli",
    "publisher": "Angular Authors",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@angular-devkit/schematics",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@angular-devkit/schematics/LICENSE"
  },
  "@angular/animations@21.2.4": {
    "licenses": "MIT",
    "repository": "https://github.com/angular/angular",
    "publisher": "angular",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@angular/animations",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@angular/animations/LICENSE"
  },
  "@angular/cdk@21.2.2": {
    "licenses": "MIT",
    "repository": "https://github.com/angular/components",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@angular/cdk",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@angular/cdk/LICENSE"
  },
  "@angular/cli@21.2.2": {
    "licenses": "MIT",
    "repository": "https://github.com/angular/angular-cli",
    "publisher": "Angular Authors",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@angular/cli",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@angular/cli/LICENSE"
  },
  "@angular/common@21.2.4": {
    "licenses": "MIT",
    "repository": "https://github.com/angular/angular",
    "publisher": "angular",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@angular/common",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@angular/common/LICENSE"
  },
  "@angular/compiler@21.2.4": {
    "licenses": "MIT",
    "repository": "https://github.com/angular/angular",
    "publisher": "angular",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@angular/compiler",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@angular/compiler/LICENSE"
  },
  "@angular/core@21.2.4": {
    "licenses": "MIT",
    "repository": "https://github.com/angular/angular",
    "publisher": "angular",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@angular/core",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@angular/core/LICENSE"
  },
  "@angular/forms@21.2.4": {
    "licenses": "MIT",
    "repository": "https://github.com/angular/angular",
    "publisher": "angular",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@angular/forms",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@angular/forms/LICENSE"
  },
  "@angular/material@21.2.2": {
    "licenses": "MIT",
    "repository": "https://github.com/angular/components",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@angular/material",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@angular/material/LICENSE"
  },
  "@angular/platform-browser-dynamic@21.2.4": {
    "licenses": "MIT",
    "repository": "https://github.com/angular/angular",
    "publisher": "angular",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@angular/platform-browser-dynamic",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@angular/platform-browser-dynamic/LICENSE"
  },
  "@angular/platform-browser@21.2.4": {
    "licenses": "MIT",
    "repository": "https://github.com/angular/angular",
    "publisher": "angular",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@angular/platform-browser",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@angular/platform-browser/LICENSE"
  },
  "@angular/pwa@21.2.2": {
    "licenses": "MIT",
    "repository": "https://github.com/angular/angular-cli",
    "publisher": "Angular Authors",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@angular/pwa",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@angular/pwa/LICENSE"
  },
  "@angular/router@21.2.4": {
    "licenses": "MIT",
    "repository": "https://github.com/angular/angular",
    "publisher": "angular",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@angular/router",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@angular/router/LICENSE"
  },
  "@angular/service-worker@21.2.4": {
    "licenses": "MIT",
    "repository": "https://github.com/angular/angular",
    "publisher": "angular",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@angular/service-worker",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@angular/service-worker/LICENSE"
  },
  "@ctrl/tinycolor@3.6.1": {
    "licenses": "MIT",
    "repository": "https://github.com/scttcper/tinycolor",
    "publisher": "Scott Cooper",
    "email": "scttcper@gmail.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@ctrl/tinycolor",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@ctrl/tinycolor/LICENSE"
  },
  "@gar/promise-retry@1.0.2": {
    "licenses": "MIT",
    "repository": "https://github.com/wraithgar/node-promise-retry",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@gar/promise-retry",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@gar/promise-retry/LICENSE"
  },
  "@hono/node-server@1.19.11": {
    "licenses": "MIT",
    "repository": "https://github.com/honojs/node-server",
    "publisher": "Yusuke Wada",
    "email": "yusuke@kamawada.com",
    "url": "https://github.com/yusukebe",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@hono/node-server",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@hono/node-server/LICENSE"
  },
  "@inquirer/ansi@1.0.2": {
    "licenses": "MIT",
    "repository": "https://github.com/SBoudrias/Inquirer.js",
    "publisher": "Simon Boudrias",
    "email": "admin@simonboudrias.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@inquirer/ansi",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@inquirer/ansi/LICENSE"
  },
  "@inquirer/checkbox@4.3.2": {
    "licenses": "MIT",
    "repository": "https://github.com/SBoudrias/Inquirer.js",
    "publisher": "Simon Boudrias",
    "email": "admin@simonboudrias.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@inquirer/checkbox",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@inquirer/checkbox/LICENSE"
  },
  "@inquirer/confirm@5.1.21": {
    "licenses": "MIT",
    "repository": "https://github.com/SBoudrias/Inquirer.js",
    "publisher": "Simon Boudrias",
    "email": "admin@simonboudrias.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@inquirer/confirm",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@inquirer/confirm/LICENSE"
  },
  "@inquirer/core@10.3.2": {
    "licenses": "MIT",
    "repository": "https://github.com/SBoudrias/Inquirer.js",
    "publisher": "Simon Boudrias",
    "email": "admin@simonboudrias.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@inquirer/core",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@inquirer/core/LICENSE"
  },
  "@inquirer/editor@4.2.23": {
    "licenses": "MIT",
    "repository": "https://github.com/SBoudrias/Inquirer.js",
    "publisher": "Simon Boudrias",
    "email": "admin@simonboudrias.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@inquirer/editor",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@inquirer/editor/LICENSE"
  },
  "@inquirer/expand@4.0.23": {
    "licenses": "MIT",
    "repository": "https://github.com/SBoudrias/Inquirer.js",
    "publisher": "Simon Boudrias",
    "email": "admin@simonboudrias.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@inquirer/expand",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@inquirer/expand/LICENSE"
  },
  "@inquirer/external-editor@1.0.3": {
    "licenses": "MIT",
    "repository": "https://github.com/SBoudrias/Inquirer.js",
    "publisher": "Simon Boudrias",
    "email": "admin@simonboudrias.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@inquirer/external-editor",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@inquirer/external-editor/LICENSE"
  },
  "@inquirer/figures@1.0.15": {
    "licenses": "MIT",
    "repository": "https://github.com/SBoudrias/Inquirer.js",
    "publisher": "Simon Boudrias",
    "email": "admin@simonboudrias.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@inquirer/figures",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@inquirer/figures/LICENSE"
  },
  "@inquirer/input@4.3.1": {
    "licenses": "MIT",
    "repository": "https://github.com/SBoudrias/Inquirer.js",
    "publisher": "Simon Boudrias",
    "email": "admin@simonboudrias.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@inquirer/input",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@inquirer/input/LICENSE"
  },
  "@inquirer/number@3.0.23": {
    "licenses": "MIT",
    "repository": "https://github.com/SBoudrias/Inquirer.js",
    "publisher": "Simon Boudrias",
    "email": "admin@simonboudrias.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@inquirer/number",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@inquirer/number/LICENSE"
  },
  "@inquirer/password@4.0.23": {
    "licenses": "MIT",
    "repository": "https://github.com/SBoudrias/Inquirer.js",
    "publisher": "Simon Boudrias",
    "email": "admin@simonboudrias.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@inquirer/password",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@inquirer/password/LICENSE"
  },
  "@inquirer/prompts@7.10.1": {
    "licenses": "MIT",
    "repository": "https://github.com/SBoudrias/Inquirer.js",
    "publisher": "Simon Boudrias",
    "email": "admin@simonboudrias.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@inquirer/prompts",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@inquirer/prompts/LICENSE"
  },
  "@inquirer/rawlist@4.1.11": {
    "licenses": "MIT",
    "repository": "https://github.com/SBoudrias/Inquirer.js",
    "publisher": "Simon Boudrias",
    "email": "admin@simonboudrias.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@inquirer/rawlist",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@inquirer/rawlist/LICENSE"
  },
  "@inquirer/search@3.2.2": {
    "licenses": "MIT",
    "repository": "https://github.com/SBoudrias/Inquirer.js",
    "publisher": "Simon Boudrias",
    "email": "admin@simonboudrias.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@inquirer/search",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@inquirer/search/LICENSE"
  },
  "@inquirer/select@4.4.2": {
    "licenses": "MIT",
    "repository": "https://github.com/SBoudrias/Inquirer.js",
    "publisher": "Simon Boudrias",
    "email": "admin@simonboudrias.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@inquirer/select",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@inquirer/select/LICENSE"
  },
  "@inquirer/type@3.0.10": {
    "licenses": "MIT",
    "repository": "https://github.com/SBoudrias/Inquirer.js",
    "publisher": "Simon Boudrias",
    "email": "admin@simonboudrias.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@inquirer/type",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@inquirer/type/LICENSE"
  },
  "@interactjs/core@1.10.27": {
    "licenses": "MIT",
    "repository": "https://github.com/taye/interact.js",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@interactjs/core",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@interactjs/core/LICENSE"
  },
  "@interactjs/interact@1.10.27": {
    "licenses": "MIT",
    "repository": "https://github.com/taye/interact.js",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@interactjs/interact",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@interactjs/interact/LICENSE"
  },
  "@interactjs/offset@1.10.27": {
    "licenses": "MIT",
    "repository": "https://github.com/taye/interact.js",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@interactjs/offset",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@interactjs/offset/LICENSE"
  },
  "@interactjs/types@1.10.27": {
    "licenses": "MIT",
    "repository": "https://github.com/taye/interact.js",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/interactjs/node_modules/@interactjs/types",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/interactjs/node_modules/@interactjs/types/LICENSE"
  },
  "@interactjs/utils@1.10.27": {
    "licenses": "MIT",
    "repository": "https://github.com/taye/interact.js",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@interactjs/utils",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@interactjs/utils/LICENSE"
  },
  "@isaacs/fs-minipass@4.0.1": {
    "licenses": "ISC",
    "repository": "https://github.com/npm/fs-minipass",
    "publisher": "Isaac Z. Schlueter",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@isaacs/fs-minipass",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@isaacs/fs-minipass/LICENSE"
  },
  "@jridgewell/sourcemap-codec@1.5.5": {
    "licenses": "MIT",
    "repository": "https://github.com/jridgewell/sourcemaps",
    "publisher": "Justin Ridgewell",
    "email": "justin@ridgewell.name",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@jridgewell/sourcemap-codec",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@jridgewell/sourcemap-codec/LICENSE"
  },
  "@listr2/prompt-adapter-inquirer@3.0.5": {
    "licenses": "MIT",
    "repository": "https://github.com/listr2/listr2",
    "publisher": "Cenk Kilic",
    "email": "cenk@kilic.dev",
    "url": "https://cenk.kilic.dev",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@listr2/prompt-adapter-inquirer",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@listr2/prompt-adapter-inquirer/LICENSE"
  },
  "@modelcontextprotocol/sdk@1.26.0": {
    "licenses": "MIT",
    "repository": "https://github.com/modelcontextprotocol/typescript-sdk",
    "publisher": "Anthropic, PBC",
    "url": "https://anthropic.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@modelcontextprotocol/sdk",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@modelcontextprotocol/sdk/LICENSE"
  },
  "@ngrx/effects@21.0.1": {
    "licenses": "MIT",
    "repository": "https://github.com/ngrx/platform",
    "publisher": "NgRx",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@ngrx/effects",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@ngrx/effects/LICENSE"
  },
  "@ngrx/store-devtools@21.0.1": {
    "licenses": "MIT",
    "repository": "https://github.com/ngrx/platform",
    "publisher": "NgRx",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@ngrx/store-devtools",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@ngrx/store-devtools/LICENSE"
  },
  "@ngrx/store@21.0.1": {
    "licenses": "MIT",
    "repository": "https://github.com/ngrx/platform",
    "publisher": "NgRx",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@ngrx/store",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@ngrx/store/LICENSE"
  },
  "@ngx-translate/core@17.0.0": {
    "licenses": "MIT",
    "repository": "https://github.com/ngx-translate/core",
    "publisher": "Andreas Löw / CodeAndWeb GmbH, Olivier Combe",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@ngx-translate/core",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@ngx-translate/core/LICENSE"
  },
  "@ngx-translate/http-loader@17.0.0": {
    "licenses": "MIT",
    "publisher": "Andreas Löw / CodeAndWeb GmbH, Olivier Combe",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@ngx-translate/http-loader",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@ngx-translate/http-loader/LICENSE"
  },
  "@npmcli/agent@4.0.0": {
    "licenses": "ISC",
    "repository": "https://github.com/npm/agent",
    "publisher": "GitHub Inc.",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@npmcli/agent",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@npmcli/agent/README.md"
  },
  "@npmcli/fs@5.0.0": {
    "licenses": "ISC",
    "repository": "https://github.com/npm/fs",
    "publisher": "GitHub Inc.",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@npmcli/fs",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@npmcli/fs/LICENSE.md"
  },
  "@npmcli/git@7.0.2": {
    "licenses": "ISC",
    "repository": "https://github.com/npm/git",
    "publisher": "GitHub Inc.",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@npmcli/git",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@npmcli/git/LICENSE"
  },
  "@npmcli/installed-package-contents@4.0.0": {
    "licenses": "ISC",
    "repository": "https://github.com/npm/installed-package-contents",
    "publisher": "GitHub Inc.",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@npmcli/installed-package-contents",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@npmcli/installed-package-contents/LICENSE"
  },
  "@npmcli/node-gyp@5.0.0": {
    "licenses": "ISC",
    "repository": "https://github.com/npm/node-gyp",
    "publisher": "GitHub Inc.",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@npmcli/node-gyp",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@npmcli/node-gyp/LICENSE"
  },
  "@npmcli/package-json@7.0.5": {
    "licenses": "ISC",
    "repository": "https://github.com/npm/package-json",
    "publisher": "GitHub Inc.",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@npmcli/package-json",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@npmcli/package-json/LICENSE"
  },
  "@npmcli/promise-spawn@9.0.1": {
    "licenses": "ISC",
    "repository": "https://github.com/npm/promise-spawn",
    "publisher": "GitHub Inc.",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@npmcli/promise-spawn",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@npmcli/promise-spawn/LICENSE"
  },
  "@npmcli/redact@4.0.0": {
    "licenses": "ISC",
    "repository": "https://github.com/npm/redact",
    "publisher": "GitHub Inc.",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@npmcli/redact",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@npmcli/redact/LICENSE"
  },
  "@npmcli/run-script@10.0.4": {
    "licenses": "ISC",
    "repository": "https://github.com/npm/run-script",
    "publisher": "GitHub Inc.",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@npmcli/run-script",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@npmcli/run-script/LICENSE"
  },
  "@schematics/angular@21.2.2": {
    "licenses": "MIT",
    "repository": "https://github.com/angular/angular-cli",
    "publisher": "Angular Authors",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@schematics/angular",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@schematics/angular/LICENSE"
  },
  "@sigstore/bundle@4.0.0": {
    "licenses": "Apache-2.0",
    "repository": "https://github.com/sigstore/sigstore-js",
    "publisher": "bdehamer@github.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@sigstore/bundle",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@sigstore/bundle/LICENSE"
  },
  "@sigstore/core@3.1.0": {
    "licenses": "Apache-2.0",
    "repository": "https://github.com/sigstore/sigstore-js",
    "publisher": "bdehamer@github.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@sigstore/core",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@sigstore/core/LICENSE"
  },
  "@sigstore/protobuf-specs@0.5.0": {
    "licenses": "Apache-2.0",
    "repository": "https://github.com/sigstore/protobuf-specs",
    "publisher": "bdehamer@github.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@sigstore/protobuf-specs",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@sigstore/protobuf-specs/LICENSE"
  },
  "@sigstore/sign@4.1.0": {
    "licenses": "Apache-2.0",
    "repository": "https://github.com/sigstore/sigstore-js",
    "publisher": "bdehamer@github.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@sigstore/sign",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@sigstore/sign/LICENSE"
  },
  "@sigstore/tuf@4.0.1": {
    "licenses": "Apache-2.0",
    "repository": "https://github.com/sigstore/sigstore-js",
    "publisher": "bdehamer@github.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@sigstore/tuf",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@sigstore/tuf/LICENSE"
  },
  "@sigstore/verify@3.1.0": {
    "licenses": "Apache-2.0",
    "repository": "https://github.com/sigstore/sigstore-js",
    "publisher": "bdehamer@github.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@sigstore/verify",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@sigstore/verify/README.md"
  },
  "@standard-schema/spec@1.1.0": {
    "licenses": "MIT",
    "repository": "https://github.com/standard-schema/standard-schema",
    "publisher": "Colin McDonnell",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@standard-schema/spec",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@standard-schema/spec/LICENSE"
  },
  "@tufjs/canonical-json@2.0.0": {
    "licenses": "MIT",
    "repository": "https://github.com/theupdateframework/tuf-js",
    "publisher": "bdehamer@github.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@tufjs/canonical-json",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@tufjs/canonical-json/LICENSE"
  },
  "@tufjs/models@4.1.0": {
    "licenses": "MIT",
    "repository": "https://github.com/theupdateframework/tuf-js",
    "publisher": "bdehamer@github.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@tufjs/models",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@tufjs/models/LICENSE"
  },
  "@types/lodash-es@4.17.12": {
    "licenses": "MIT",
    "repository": "https://github.com/DefinitelyTyped/DefinitelyTyped",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@types/lodash-es",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@types/lodash-es/LICENSE"
  },
  "@types/lodash@4.17.24": {
    "licenses": "MIT",
    "repository": "https://github.com/DefinitelyTyped/DefinitelyTyped",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@types/lodash",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@types/lodash/LICENSE"
  },
  "@types/node@18.19.130": {
    "licenses": "MIT",
    "repository": "https://github.com/DefinitelyTyped/DefinitelyTyped",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@types/node",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@types/node/LICENSE"
  },
  "@yarnpkg/lockfile@1.1.0": {
    "licenses": "BSD-2-Clause",
    "repository": "https://github.com/yarnpkg/yarn/blob/master/packages/lockfile",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@yarnpkg/lockfile",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@yarnpkg/lockfile/README.md"
  },
  "abbrev@4.0.0": {
    "licenses": "ISC",
    "repository": "https://github.com/npm/abbrev-js",
    "publisher": "GitHub Inc.",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/node-gyp/node_modules/abbrev",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/node-gyp/node_modules/abbrev/LICENSE"
  },
  "accepts@2.0.0": {
    "licenses": "MIT",
    "repository": "https://github.com/jshttp/accepts",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/accepts",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/accepts/LICENSE"
  },
  "agent-base@7.1.4": {
    "licenses": "MIT",
    "repository": "https://github.com/TooTallNate/proxy-agents",
    "publisher": "Nathan Rajlich",
    "email": "nathan@tootallnate.net",
    "url": "http://n8.io/",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/agent-base",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/agent-base/LICENSE"
  },
  "ajv-formats@3.0.1": {
    "licenses": "MIT",
    "repository": "https://github.com/ajv-validator/ajv-formats",
    "publisher": "Evgeny Poberezkin",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/ajv-formats",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/ajv-formats/LICENSE"
  },
  "ajv@8.18.0": {
    "licenses": "MIT",
    "repository": "https://github.com/ajv-validator/ajv",
    "publisher": "Evgeny Poberezkin",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/ajv",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/ajv/LICENSE"
  },
  "algoliasearch@5.48.1": {
    "licenses": "MIT",
    "repository": "https://github.com/algolia/algoliasearch-client-javascript",
    "publisher": "Algolia",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/algoliasearch",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/algoliasearch/LICENSE"
  },
  "ansi-escapes@7.3.0": {
    "licenses": "MIT",
    "repository": "https://github.com/sindresorhus/ansi-escapes",
    "publisher": "Sindre Sorhus",
    "email": "sindresorhus@gmail.com",
    "url": "https://sindresorhus.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/ansi-escapes",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/ansi-escapes/license"
  },
  "ansi-regex@5.0.1": {
    "licenses": "MIT",
    "repository": "https://github.com/chalk/ansi-regex",
    "publisher": "Sindre Sorhus",
    "email": "sindresorhus@gmail.com",
    "url": "sindresorhus.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/wrap-ansi/node_modules/ansi-regex",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/wrap-ansi/node_modules/ansi-regex/license"
  },
  "ansi-regex@6.2.2": {
    "licenses": "MIT",
    "repository": "https://github.com/chalk/ansi-regex",
    "publisher": "Sindre Sorhus",
    "email": "sindresorhus@gmail.com",
    "url": "https://sindresorhus.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/ansi-regex",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/ansi-regex/license"
  },
  "ansi-styles@4.3.0": {
    "licenses": "MIT",
    "repository": "https://github.com/chalk/ansi-styles",
    "publisher": "Sindre Sorhus",
    "email": "sindresorhus@gmail.com",
    "url": "sindresorhus.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/ansi-styles",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/ansi-styles/license"
  },
  "ansi-styles@6.2.3": {
    "licenses": "MIT",
    "repository": "https://github.com/chalk/ansi-styles",
    "publisher": "Sindre Sorhus",
    "email": "sindresorhus@gmail.com",
    "url": "https://sindresorhus.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/slice-ansi/node_modules/ansi-styles",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/slice-ansi/node_modules/ansi-styles/license"
  },
  "balanced-match@4.0.4": {
    "licenses": "MIT",
    "repository": "https://github.com/juliangruber/balanced-match",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/balanced-match",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/balanced-match/LICENSE.md"
  },
  "body-parser@2.2.2": {
    "licenses": "MIT",
    "repository": "https://github.com/expressjs/body-parser",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/body-parser",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/body-parser/LICENSE"
  },
  "brace-expansion@5.0.4": {
    "licenses": "MIT",
    "repository": "https://github.com/juliangruber/brace-expansion",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/brace-expansion",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/brace-expansion/LICENSE"
  },
  "bytes@3.1.2": {
    "licenses": "MIT",
    "repository": "https://github.com/visionmedia/bytes.js",
    "publisher": "TJ Holowaychuk",
    "email": "tj@vision-media.ca",
    "url": "http://tjholowaychuk.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/bytes",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/bytes/LICENSE"
  },
  "cacache@20.0.3": {
    "licenses": "ISC",
    "repository": "https://github.com/npm/cacache",
    "publisher": "GitHub Inc.",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/cacache",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/cacache/LICENSE.md"
  },
  "call-bind-apply-helpers@1.0.2": {
    "licenses": "MIT",
    "repository": "https://github.com/ljharb/call-bind-apply-helpers",
    "publisher": "Jordan Harband",
    "email": "ljharb@gmail.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/call-bind-apply-helpers",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/call-bind-apply-helpers/LICENSE"
  },
  "call-bound@1.0.4": {
    "licenses": "MIT",
    "repository": "https://github.com/ljharb/call-bound",
    "publisher": "Jordan Harband",
    "email": "ljharb@gmail.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/call-bound",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/call-bound/LICENSE"
  },
  "chalk@5.6.2": {
    "licenses": "MIT",
    "repository": "https://github.com/chalk/chalk",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/ora/node_modules/chalk",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/ora/node_modules/chalk/license"
  },
  "chardet@2.1.1": {
    "licenses": "MIT",
    "repository": "https://github.com/runk/node-chardet",
    "publisher": "Dmitry Shirokov",
    "email": "deadrunk@gmail.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/chardet",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/chardet/LICENSE"
  },
  "chokidar@5.0.0": {
    "licenses": "MIT",
    "repository": "https://github.com/paulmillr/chokidar",
    "publisher": "Paul Miller",
    "url": "https://paulmillr.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/chokidar",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/chokidar/LICENSE"
  },
  "chownr@3.0.0": {
    "licenses": "BlueOak-1.0.0",
    "repository": "https://github.com/isaacs/chownr",
    "publisher": "Isaac Z. Schlueter",
    "email": "i@izs.me",
    "url": "http://blog.izs.me/",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/chownr",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/chownr/LICENSE.md"
  },
  "cli-cursor@5.0.0": {
    "licenses": "MIT",
    "repository": "https://github.com/sindresorhus/cli-cursor",
    "publisher": "Sindre Sorhus",
    "email": "sindresorhus@gmail.com",
    "url": "https://sindresorhus.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/cli-cursor",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/cli-cursor/license"
  },
  "cli-spinners@3.4.0": {
    "licenses": "MIT",
    "repository": "https://github.com/sindresorhus/cli-spinners",
    "publisher": "Sindre Sorhus",
    "email": "sindresorhus@gmail.com",
    "url": "https://sindresorhus.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/cli-spinners",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/cli-spinners/license"
  },
  "cli-truncate@5.2.0": {
    "licenses": "MIT",
    "repository": "https://github.com/sindresorhus/cli-truncate",
    "publisher": "Sindre Sorhus",
    "email": "sindresorhus@gmail.com",
    "url": "https://sindresorhus.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/cli-truncate",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/cli-truncate/license"
  },
  "cli-width@4.1.0": {
    "licenses": "ISC",
    "repository": "https://github.com/knownasilya/cli-width",
    "publisher": "Ilya Radchenko",
    "email": "knownasilya@gmail.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/cli-width",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/cli-width/LICENSE"
  },
  "cliui@9.0.1": {
    "licenses": "ISC",
    "repository": "https://github.com/yargs/cliui",
    "publisher": "Ben Coe",
    "email": "ben@npmjs.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/cliui",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/cliui/LICENSE.txt"
  },
  "codsen-utils@1.7.3": {
    "licenses": "MIT",
    "repository": "https://github.com/codsen/codsen",
    "publisher": "Roy Revelt",
    "email": "roy@codsen.com",
    "url": "https://codsen.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/codsen-utils",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/codsen-utils/LICENSE"
  },
  "color-convert@2.0.1": {
    "licenses": "MIT",
    "repository": "https://github.com/Qix-/color-convert",
    "publisher": "Heather Arthur",
    "email": "fayearthur@gmail.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/ansi-styles/node_modules/color-convert",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/ansi-styles/node_modules/color-convert/LICENSE"
  },
  "color-convert@3.1.3": {
    "licenses": "MIT",
    "repository": "https://github.com/Qix-/color-convert",
    "publisher": "Josh Junon",
    "email": "josh@junon.me",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/color-convert",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/color-convert/LICENSE"
  },
  "color-name@1.1.4": {
    "licenses": "MIT",
    "repository": "https://github.com/colorjs/color-name",
    "publisher": "DY",
    "email": "dfcreative@gmail.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/ansi-styles/node_modules/color-name",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/ansi-styles/node_modules/color-name/LICENSE"
  },
  "color-name@2.1.0": {
    "licenses": "MIT",
    "repository": "https://github.com/colorjs/color-name",
    "publisher": "Dmitry Iv",
    "email": "dfcreative@gmail.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/color-name",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/color-name/LICENSE"
  },
  "color-string@2.1.4": {
    "licenses": "MIT",
    "repository": "https://github.com/Qix-/color-string",
    "publisher": "Josh Junon",
    "url": "https://github.com/qix-",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/color-string",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/color-string/LICENSE"
  },
  "color@5.0.3": {
    "licenses": "MIT",
    "repository": "https://github.com/Qix-/color",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/color",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/color/LICENSE"
  },
  "colorette@2.0.20": {
    "licenses": "MIT",
    "repository": "https://github.com/jorgebucaran/colorette",
    "publisher": "Jorge Bucaran",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/colorette",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/colorette/LICENSE.md"
  },
  "content-disposition@1.0.1": {
    "licenses": "MIT",
    "repository": "https://github.com/jshttp/content-disposition",
    "publisher": "Douglas Christopher Wilson",
    "email": "doug@somethingdoug.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/content-disposition",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/content-disposition/LICENSE"
  },
  "content-type@1.0.5": {
    "licenses": "MIT",
    "repository": "https://github.com/jshttp/content-type",
    "publisher": "Douglas Christopher Wilson",
    "email": "doug@somethingdoug.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/content-type",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/content-type/LICENSE"
  },
  "cookie-signature@1.2.2": {
    "licenses": "MIT",
    "repository": "https://github.com/visionmedia/node-cookie-signature",
    "publisher": "TJ Holowaychuk",
    "email": "tj@learnboost.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/cookie-signature",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/cookie-signature/LICENSE"
  },
  "cookie@0.7.2": {
    "licenses": "MIT",
    "repository": "https://github.com/jshttp/cookie",
    "publisher": "Roman Shtylman",
    "email": "shtylman@gmail.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/cookie",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/cookie/LICENSE"
  },
  "cors@2.8.6": {
    "licenses": "MIT",
    "repository": "https://github.com/expressjs/cors",
    "publisher": "Troy Goode",
    "email": "troygoode@gmail.com",
    "url": "https://github.com/troygoode/",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/cors",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/cors/LICENSE"
  },
  "cross-spawn@7.0.6": {
    "licenses": "MIT",
    "repository": "https://github.com/moxystudio/node-cross-spawn",
    "publisher": "André Cruz",
    "email": "andre@moxy.studio",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/cross-spawn",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/cross-spawn/LICENSE"
  },
  "debug@4.4.3": {
    "licenses": "MIT",
    "repository": "https://github.com/debug-js/debug",
    "publisher": "Josh Junon",
    "url": "https://github.com/qix-",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/debug",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/debug/LICENSE"
  },
  "depd@2.0.0": {
    "licenses": "MIT",
    "repository": "https://github.com/dougwilson/nodejs-depd",
    "publisher": "Douglas Christopher Wilson",
    "email": "doug@somethingdoug.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/depd",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/depd/LICENSE"
  },
  "dexie@3.2.7": {
    "licenses": "Apache-2.0",
    "repository": "https://github.com/dfahlander/Dexie.js",
    "publisher": "David Fahlander",
    "email": "https://github.com/dfahlander",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/dexie",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/dexie/LICENSE",
    "noticeFile": "/home/dennis/Projects/angular2-processmanager/node_modules/dexie/NOTICE"
  },
  "dunder-proto@1.0.1": {
    "licenses": "MIT",
    "repository": "https://github.com/es-shims/dunder-proto",
    "publisher": "Jordan Harband",
    "email": "ljharb@gmail.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/dunder-proto",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/dunder-proto/LICENSE"
  },
  "ee-first@1.1.1": {
    "licenses": "MIT",
    "repository": "https://github.com/jonathanong/ee-first",
    "publisher": "Jonathan Ong",
    "email": "me@jongleberry.com",
    "url": "http://jongleberry.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/ee-first",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/ee-first/LICENSE"
  },
  "emoji-regex@10.6.0": {
    "licenses": "MIT",
    "repository": "https://github.com/mathiasbynens/emoji-regex",
    "publisher": "Mathias Bynens",
    "url": "https://mathiasbynens.be/",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/log-update/node_modules/emoji-regex",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/log-update/node_modules/emoji-regex/LICENSE-MIT.txt"
  },
  "emoji-regex@8.0.0": {
    "licenses": "MIT",
    "repository": "https://github.com/mathiasbynens/emoji-regex",
    "publisher": "Mathias Bynens",
    "url": "https://mathiasbynens.be/",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/emoji-regex",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/emoji-regex/LICENSE-MIT.txt"
  },
  "encodeurl@2.0.0": {
    "licenses": "MIT",
    "repository": "https://github.com/pillarjs/encodeurl",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/encodeurl",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/encodeurl/LICENSE"
  },
  "entities@6.0.1": {
    "licenses": "BSD-2-Clause",
    "repository": "https://github.com/fb55/entities",
    "publisher": "Felix Boehm",
    "email": "me@feedic.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/entities",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/entities/LICENSE"
  },
  "env-paths@2.2.1": {
    "licenses": "MIT",
    "repository": "https://github.com/sindresorhus/env-paths",
    "publisher": "Sindre Sorhus",
    "email": "sindresorhus@gmail.com",
    "url": "sindresorhus.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/env-paths",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/env-paths/license"
  },
  "environment@1.1.0": {
    "licenses": "MIT",
    "repository": "https://github.com/sindresorhus/environment",
    "publisher": "Sindre Sorhus",
    "email": "sindresorhus@gmail.com",
    "url": "https://sindresorhus.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/environment",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/environment/license"
  },
  "err-code@2.0.3": {
    "licenses": "MIT",
    "repository": "https://github.com/IndigoUnited/js-err-code",
    "publisher": "IndigoUnited",
    "email": "hello@indigounited.com",
    "url": "http://indigounited.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/err-code",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/err-code/README.md"
  },
  "es-define-property@1.0.1": {
    "licenses": "MIT",
    "repository": "https://github.com/ljharb/es-define-property",
    "publisher": "Jordan Harband",
    "email": "ljharb@gmail.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/es-define-property",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/es-define-property/LICENSE"
  },
  "es-errors@1.3.0": {
    "licenses": "MIT",
    "repository": "https://github.com/ljharb/es-errors",
    "publisher": "Jordan Harband",
    "email": "ljharb@gmail.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/es-errors",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/es-errors/LICENSE"
  },
  "es-object-atoms@1.1.1": {
    "licenses": "MIT",
    "repository": "https://github.com/ljharb/es-object-atoms",
    "publisher": "Jordan Harband",
    "email": "ljharb@gmail.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/es-object-atoms",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/es-object-atoms/LICENSE"
  },
  "escalade@3.2.0": {
    "licenses": "MIT",
    "repository": "https://github.com/lukeed/escalade",
    "publisher": "Luke Edwards",
    "email": "luke.edwards05@gmail.com",
    "url": "https://lukeed.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/escalade",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/escalade/license"
  },
  "escape-html@1.0.3": {
    "licenses": "MIT",
    "repository": "https://github.com/component/escape-html",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/escape-html",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/escape-html/LICENSE"
  },
  "etag@1.8.1": {
    "licenses": "MIT",
    "repository": "https://github.com/jshttp/etag",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/etag",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/etag/LICENSE"
  },
  "eventemitter3@5.0.4": {
    "licenses": "MIT",
    "repository": "https://github.com/primus/eventemitter3",
    "publisher": "Arnout Kazemier",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/listr2/node_modules/eventemitter3",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/listr2/node_modules/eventemitter3/LICENSE"
  },
  "eventsource-parser@3.0.6": {
    "licenses": "MIT",
    "repository": "https://github.com/rexxars/eventsource-parser",
    "publisher": "Espen Hovlandsdal",
    "email": "espen@hovlandsdal.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/eventsource-parser",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/eventsource-parser/LICENSE"
  },
  "eventsource@3.0.7": {
    "licenses": "MIT",
    "repository": "git://git@github.com/EventSource/eventsource",
    "publisher": "Espen Hovlandsdal",
    "email": "espen@hovlandsdal.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/eventsource",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/eventsource/LICENSE"
  },
  "exponential-backoff@3.1.3": {
    "licenses": "Apache-2.0",
    "repository": "https://github.com/coveooss/exponential-backoff",
    "publisher": "Sami Sayegh",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/exponential-backoff",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/exponential-backoff/LICENSE"
  },
  "express-rate-limit@8.3.1": {
    "licenses": "MIT",
    "repository": "https://github.com/express-rate-limit/express-rate-limit",
    "publisher": "Nathan Friedly",
    "url": "http://nfriedly.com/",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/express-rate-limit",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/express-rate-limit/license.md"
  },
  "express@5.2.1": {
    "licenses": "MIT",
    "repository": "https://github.com/expressjs/express",
    "publisher": "TJ Holowaychuk",
    "email": "tj@vision-media.ca",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/express",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/express/LICENSE"
  },
  "fast-deep-equal@3.1.3": {
    "licenses": "MIT",
    "repository": "https://github.com/epoberezkin/fast-deep-equal",
    "publisher": "Evgeny Poberezkin",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/fast-deep-equal",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/fast-deep-equal/LICENSE"
  },
  "fast-uri@3.1.0": {
    "licenses": "BSD-3-Clause",
    "repository": "https://github.com/fastify/fast-uri",
    "publisher": "Vincent Le Goff",
    "email": "vince.legoff@gmail.com",
    "url": "https://github.com/zekth",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/fast-uri",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/fast-uri/LICENSE"
  },
  "fdir@6.5.0": {
    "licenses": "MIT",
    "repository": "https://github.com/thecodrr/fdir",
    "publisher": "thecodrr",
    "email": "thecodrr@protonmail.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/fdir",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/fdir/LICENSE"
  },
  "finalhandler@2.1.1": {
    "licenses": "MIT",
    "repository": "https://github.com/pillarjs/finalhandler",
    "publisher": "Douglas Christopher Wilson",
    "email": "doug@somethingdoug.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/finalhandler",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/finalhandler/LICENSE"
  },
  "forwarded@0.2.0": {
    "licenses": "MIT",
    "repository": "https://github.com/jshttp/forwarded",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/forwarded",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/forwarded/LICENSE"
  },
  "fresh@2.0.0": {
    "licenses": "MIT",
    "repository": "https://github.com/jshttp/fresh",
    "publisher": "TJ Holowaychuk",
    "email": "tj@vision-media.ca",
    "url": "http://tjholowaychuk.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/fresh",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/fresh/LICENSE"
  },
  "fs-minipass@3.0.3": {
    "licenses": "ISC",
    "repository": "https://github.com/npm/fs-minipass",
    "publisher": "GitHub Inc.",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/fs-minipass",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/fs-minipass/LICENSE"
  },
  "function-bind@1.1.2": {
    "licenses": "MIT",
    "repository": "https://github.com/Raynos/function-bind",
    "publisher": "Raynos",
    "email": "raynos2@gmail.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/function-bind",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/function-bind/LICENSE"
  },
  "get-caller-file@2.0.5": {
    "licenses": "ISC",
    "repository": "https://github.com/stefanpenner/get-caller-file",
    "publisher": "Stefan Penner",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/get-caller-file",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/get-caller-file/LICENSE.md"
  },
  "get-east-asian-width@1.5.0": {
    "licenses": "MIT",
    "repository": "https://github.com/sindresorhus/get-east-asian-width",
    "publisher": "Sindre Sorhus",
    "email": "sindresorhus@gmail.com",
    "url": "https://sindresorhus.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/get-east-asian-width",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/get-east-asian-width/license"
  },
  "get-intrinsic@1.3.0": {
    "licenses": "MIT",
    "repository": "https://github.com/ljharb/get-intrinsic",
    "publisher": "Jordan Harband",
    "email": "ljharb@gmail.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/get-intrinsic",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/get-intrinsic/LICENSE"
  },
  "get-proto@1.0.1": {
    "licenses": "MIT",
    "repository": "https://github.com/ljharb/get-proto",
    "publisher": "Jordan Harband",
    "email": "ljharb@gmail.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/get-proto",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/get-proto/LICENSE"
  },
  "glob@13.0.6": {
    "licenses": "BlueOak-1.0.0",
    "repository": "https://github.com/isaacs/node-glob",
    "publisher": "Isaac Z. Schlueter",
    "email": "i@izs.me",
    "url": "https://blog.izs.me/",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@npmcli/package-json/node_modules/glob",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@npmcli/package-json/node_modules/glob/LICENSE.md"
  },
  "gopd@1.2.0": {
    "licenses": "MIT",
    "repository": "https://github.com/ljharb/gopd",
    "publisher": "Jordan Harband",
    "email": "ljharb@gmail.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/gopd",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/gopd/LICENSE"
  },
  "graceful-fs@4.2.11": {
    "licenses": "ISC",
    "repository": "https://github.com/isaacs/node-graceful-fs",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/graceful-fs",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/graceful-fs/LICENSE"
  },
  "has-symbols@1.1.0": {
    "licenses": "MIT",
    "repository": "https://github.com/inspect-js/has-symbols",
    "publisher": "Jordan Harband",
    "email": "ljharb@gmail.com",
    "url": "http://ljharb.codes",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/has-symbols",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/has-symbols/LICENSE"
  },
  "hasown@2.0.2": {
    "licenses": "MIT",
    "repository": "https://github.com/inspect-js/hasOwn",
    "publisher": "Jordan Harband",
    "email": "ljharb@gmail.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/hasown",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/hasown/LICENSE"
  },
  "hono@4.12.7": {
    "licenses": "MIT",
    "repository": "https://github.com/honojs/hono",
    "publisher": "Yusuke Wada",
    "email": "yusuke@kamawada.com",
    "url": "https://github.com/yusukebe",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/hono",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/hono/LICENSE"
  },
  "hosted-git-info@9.0.2": {
    "licenses": "ISC",
    "repository": "https://github.com/npm/hosted-git-info",
    "publisher": "GitHub Inc.",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/hosted-git-info",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/hosted-git-info/LICENSE"
  },
  "html-entities@2.6.0": {
    "licenses": "MIT",
    "repository": "https://github.com/mdevils/html-entities",
    "publisher": "Marat Dulin",
    "email": "mdevils@yandex.ru",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/html-entities",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/html-entities/LICENSE"
  },
  "http-cache-semantics@4.2.0": {
    "licenses": "BSD-2-Clause",
    "repository": "https://github.com/kornelski/http-cache-semantics",
    "publisher": "Kornel Lesiński",
    "email": "npms2@geekhood.net",
    "url": "https://kornel.ski/",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/http-cache-semantics",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/http-cache-semantics/LICENSE"
  },
  "http-errors@2.0.1": {
    "licenses": "MIT",
    "repository": "https://github.com/jshttp/http-errors",
    "publisher": "Jonathan Ong",
    "email": "me@jongleberry.com",
    "url": "http://jongleberry.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/http-errors",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/http-errors/LICENSE"
  },
  "http-proxy-agent@7.0.2": {
    "licenses": "MIT",
    "repository": "https://github.com/TooTallNate/proxy-agents",
    "publisher": "Nathan Rajlich",
    "email": "nathan@tootallnate.net",
    "url": "http://n8.io/",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/http-proxy-agent",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/http-proxy-agent/LICENSE"
  },
  "https-proxy-agent@7.0.6": {
    "licenses": "MIT",
    "repository": "https://github.com/TooTallNate/proxy-agents",
    "publisher": "Nathan Rajlich",
    "email": "nathan@tootallnate.net",
    "url": "http://n8.io/",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/https-proxy-agent",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/https-proxy-agent/LICENSE"
  },
  "iconv-lite@0.7.2": {
    "licenses": "MIT",
    "repository": "https://github.com/pillarjs/iconv-lite",
    "publisher": "Alexander Shtuchkin",
    "email": "ashtuchkin@gmail.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/iconv-lite",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/iconv-lite/LICENSE"
  },
  "ignore-walk@8.0.0": {
    "licenses": "ISC",
    "repository": "https://github.com/npm/ignore-walk",
    "publisher": "GitHub Inc.",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/ignore-walk",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/ignore-walk/LICENSE"
  },
  "immutable@4.3.8": {
    "licenses": "MIT",
    "repository": "https://github.com/immutable-js/immutable-js",
    "publisher": "Lee Byron",
    "url": "https://github.com/leebyron",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/immutable",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/immutable/LICENSE"
  },
  "imurmurhash@0.1.4": {
    "licenses": "MIT",
    "repository": "https://github.com/jensyt/imurmurhash-js",
    "publisher": "Jens Taylor",
    "email": "jensyt@gmail.com",
    "url": "https://github.com/homebrewing",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/imurmurhash",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/imurmurhash/README.md"
  },
  "inherits@2.0.4": {
    "licenses": "ISC",
    "repository": "https://github.com/isaacs/inherits",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/inherits",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/inherits/LICENSE"
  },
  "ini@6.0.0": {
    "licenses": "ISC",
    "repository": "https://github.com/npm/ini",
    "publisher": "GitHub Inc.",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/ini",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/ini/LICENSE"
  },
  "interactjs@1.10.27": {
    "licenses": "MIT",
    "repository": "https://github.com/taye/interact.js",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/interactjs",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/interactjs/LICENSE"
  },
  "ip-address@10.1.0": {
    "licenses": "MIT",
    "repository": "https://github.com/beaugunderson/ip-address",
    "publisher": "Beau Gunderson",
    "email": "beau@beaugunderson.com",
    "url": "https://beaugunderson.com/",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/ip-address",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/ip-address/LICENSE"
  },
  "ipaddr.js@1.9.1": {
    "licenses": "MIT",
    "repository": "https://github.com/whitequark/ipaddr.js",
    "publisher": "whitequark",
    "email": "whitequark@whitequark.org",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/ipaddr.js",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/ipaddr.js/LICENSE"
  },
  "is-fullwidth-code-point@3.0.0": {
    "licenses": "MIT",
    "repository": "https://github.com/sindresorhus/is-fullwidth-code-point",
    "publisher": "Sindre Sorhus",
    "email": "sindresorhus@gmail.com",
    "url": "sindresorhus.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/wrap-ansi/node_modules/is-fullwidth-code-point",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/wrap-ansi/node_modules/is-fullwidth-code-point/license"
  },
  "is-fullwidth-code-point@5.1.0": {
    "licenses": "MIT",
    "repository": "https://github.com/sindresorhus/is-fullwidth-code-point",
    "publisher": "Sindre Sorhus",
    "email": "sindresorhus@gmail.com",
    "url": "https://sindresorhus.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/is-fullwidth-code-point",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/is-fullwidth-code-point/license"
  },
  "is-interactive@2.0.0": {
    "licenses": "MIT",
    "repository": "https://github.com/sindresorhus/is-interactive",
    "publisher": "Sindre Sorhus",
    "email": "sindresorhus@gmail.com",
    "url": "https://sindresorhus.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/is-interactive",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/is-interactive/license"
  },
  "is-promise@4.0.0": {
    "licenses": "MIT",
    "repository": "https://github.com/then/is-promise",
    "publisher": "ForbesLindesay",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/is-promise",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/is-promise/LICENSE"
  },
  "is-unicode-supported@2.1.0": {
    "licenses": "MIT",
    "repository": "https://github.com/sindresorhus/is-unicode-supported",
    "publisher": "Sindre Sorhus",
    "email": "sindresorhus@gmail.com",
    "url": "https://sindresorhus.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/is-unicode-supported",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/is-unicode-supported/license"
  },
  "isexe@2.0.0": {
    "licenses": "ISC",
    "repository": "https://github.com/isaacs/isexe",
    "publisher": "Isaac Z. Schlueter",
    "email": "i@izs.me",
    "url": "http://blog.izs.me/",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/isexe",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/isexe/LICENSE"
  },
  "isexe@4.0.0": {
    "licenses": "BlueOak-1.0.0",
    "repository": "https://github.com/isaacs/isexe",
    "publisher": "Isaac Z. Schlueter",
    "email": "i@izs.me",
    "url": "http://blog.izs.me/",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@npmcli/promise-spawn/node_modules/isexe",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@npmcli/promise-spawn/node_modules/isexe/LICENSE.md"
  },
  "jose@6.2.1": {
    "licenses": "MIT",
    "repository": "https://github.com/panva/jose",
    "publisher": "Filip Skokan",
    "email": "panva.ip@gmail.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/jose",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/jose/LICENSE.md"
  },
  "jquery@3.7.1": {
    "licenses": "MIT",
    "repository": "https://github.com/jquery/jquery",
    "publisher": "OpenJS Foundation and other contributors",
    "url": "https://github.com/jquery/jquery/blob/3.7.1/AUTHORS.txt",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/jquery",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/jquery/LICENSE.txt"
  },
  "js-cookie@3.0.5": {
    "licenses": "MIT",
    "repository": "https://github.com/js-cookie/js-cookie",
    "publisher": "Klaus Hartl",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/js-cookie",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/js-cookie/LICENSE"
  },
  "json-parse-even-better-errors@5.0.0": {
    "licenses": "MIT",
    "repository": "https://github.com/npm/json-parse-even-better-errors",
    "publisher": "GitHub Inc.",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/json-parse-even-better-errors",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/json-parse-even-better-errors/LICENSE.md"
  },
  "json-schema-traverse@1.0.0": {
    "licenses": "MIT",
    "repository": "https://github.com/epoberezkin/json-schema-traverse",
    "publisher": "Evgeny Poberezkin",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/json-schema-traverse",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/json-schema-traverse/LICENSE"
  },
  "json-schema-typed@8.0.2": {
    "licenses": "BSD-2-Clause",
    "repository": "https://github.com/RemyRylan/json-schema-typed",
    "publisher": "Remy Rylan",
    "url": "https://github.com/RemyRylan",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/json-schema-typed",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/json-schema-typed/LICENSE.md"
  },
  "jsonc-parser@3.3.1": {
    "licenses": "MIT",
    "repository": "https://github.com/microsoft/node-jsonc-parser",
    "publisher": "Microsoft Corporation",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/jsonc-parser",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/jsonc-parser/LICENSE.md"
  },
  "jsonparse@1.3.1": {
    "licenses": "MIT",
    "repository": "https://github.com/creationix/jsonparse",
    "publisher": "Tim Caswell",
    "email": "tim@creationix.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/jsonparse",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/jsonparse/LICENSE"
  },
  "jwt-decode@4.0.0": {
    "licenses": "MIT",
    "repository": "https://github.com/auth0/jwt-decode",
    "publisher": "Jose F. Romaniello",
    "email": "jfromaniello@gmail.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/jwt-decode",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/jwt-decode/LICENSE"
  },
  "listr2@9.0.5": {
    "licenses": "MIT",
    "repository": "https://github.com/listr2/listr2",
    "publisher": "Cenk Kilic",
    "email": "cenk@kilic.dev",
    "url": "https://cenk.kilic.dev",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/listr2",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/listr2/LICENSE"
  },
  "lodash-es@4.17.23": {
    "licenses": "MIT",
    "repository": "https://github.com/lodash/lodash",
    "publisher": "John-David Dalton",
    "email": "john.david.dalton@gmail.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/lodash-es",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/lodash-es/LICENSE"
  },
  "log-symbols@7.0.1": {
    "licenses": "MIT",
    "repository": "https://github.com/sindresorhus/log-symbols",
    "publisher": "Sindre Sorhus",
    "email": "sindresorhus@gmail.com",
    "url": "https://sindresorhus.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/log-symbols",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/log-symbols/license"
  },
  "log-update@6.1.0": {
    "licenses": "MIT",
    "repository": "https://github.com/sindresorhus/log-update",
    "publisher": "Sindre Sorhus",
    "email": "sindresorhus@gmail.com",
    "url": "https://sindresorhus.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/log-update",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/log-update/license"
  },
  "lru-cache@11.2.6": {
    "licenses": "BlueOak-1.0.0",
    "repository": "https://github.com/isaacs/node-lru-cache",
    "publisher": "Isaac Z. Schlueter",
    "email": "i@izs.me",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@npmcli/git/node_modules/lru-cache",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@npmcli/git/node_modules/lru-cache/LICENSE.md"
  },
  "magic-string@0.30.21": {
    "licenses": "MIT",
    "repository": "https://github.com/Rich-Harris/magic-string",
    "publisher": "Rich Harris",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/magic-string",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/magic-string/LICENSE"
  },
  "make-fetch-happen@15.0.4": {
    "licenses": "ISC",
    "repository": "https://github.com/npm/make-fetch-happen",
    "publisher": "GitHub Inc.",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/make-fetch-happen",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/make-fetch-happen/LICENSE"
  },
  "material-colors@1.2.6": {
    "licenses": "ISC",
    "repository": "https://github.com/shuhei/material-colors",
    "publisher": "Shuhei Kagawa",
    "email": "shuhei.kagawa@gmail.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/material-colors",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/material-colors/LICENSE"
  },
  "math-intrinsics@1.1.0": {
    "licenses": "MIT",
    "repository": "https://github.com/es-shims/math-intrinsics",
    "publisher": "Jordan Harband",
    "email": "ljharb@gmail.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/math-intrinsics",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/math-intrinsics/LICENSE"
  },
  "media-typer@1.1.0": {
    "licenses": "MIT",
    "repository": "https://github.com/jshttp/media-typer",
    "publisher": "Douglas Christopher Wilson",
    "email": "doug@somethingdoug.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/media-typer",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/media-typer/LICENSE"
  },
  "merge-descriptors@2.0.0": {
    "licenses": "MIT",
    "repository": "https://github.com/sindresorhus/merge-descriptors",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/merge-descriptors",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/merge-descriptors/license"
  },
  "mime-db@1.54.0": {
    "licenses": "MIT",
    "repository": "https://github.com/jshttp/mime-db",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/mime-db",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/mime-db/LICENSE"
  },
  "mime-types@3.0.2": {
    "licenses": "MIT",
    "repository": "https://github.com/jshttp/mime-types",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/mime-types",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/mime-types/LICENSE"
  },
  "mimic-function@5.0.1": {
    "licenses": "MIT",
    "repository": "https://github.com/sindresorhus/mimic-function",
    "publisher": "Sindre Sorhus",
    "email": "sindresorhus@gmail.com",
    "url": "https://sindresorhus.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/mimic-function",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/mimic-function/license"
  },
  "minimatch@10.2.4": {
    "licenses": "BlueOak-1.0.0",
    "repository": "https://github.com/isaacs/minimatch",
    "publisher": "Isaac Z. Schlueter",
    "email": "i@izs.me",
    "url": "http://blog.izs.me",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/minimatch",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/minimatch/LICENSE.md"
  },
  "minipass-collect@2.0.1": {
    "licenses": "ISC",
    "repository": "https://github.com/isaacs/minipass-collect",
    "publisher": "Isaac Z. Schlueter",
    "email": "i@izs.me",
    "url": "https://izs.me",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/minipass-collect",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/minipass-collect/LICENSE"
  },
  "minipass-fetch@5.0.2": {
    "licenses": "MIT",
    "repository": "https://github.com/npm/minipass-fetch",
    "publisher": "GitHub Inc.",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/minipass-fetch",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/minipass-fetch/LICENSE"
  },
  "minipass-flush@1.0.5": {
    "licenses": "ISC",
    "repository": "https://github.com/isaacs/minipass-flush",
    "publisher": "Isaac Z. Schlueter",
    "email": "i@izs.me",
    "url": "https://izs.me",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/minipass-flush",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/minipass-flush/LICENSE"
  },
  "minipass-pipeline@1.2.4": {
    "licenses": "ISC",
    "publisher": "Isaac Z. Schlueter",
    "email": "i@izs.me",
    "url": "https://izs.me",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/minipass-pipeline",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/minipass-pipeline/LICENSE"
  },
  "minipass-sized@2.0.0": {
    "licenses": "ISC",
    "repository": "https://github.com/isaacs/minipass-sized",
    "publisher": "Isaac Z. Schlueter",
    "email": "i@izs.me",
    "url": "https://izs.me",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/minipass-sized",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/minipass-sized/LICENSE"
  },
  "minipass@3.3.6": {
    "licenses": "ISC",
    "repository": "https://github.com/isaacs/minipass",
    "publisher": "Isaac Z. Schlueter",
    "email": "i@izs.me",
    "url": "http://blog.izs.me/",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/minipass-flush/node_modules/minipass",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/minipass-flush/node_modules/minipass/LICENSE"
  },
  "minipass@7.1.3": {
    "licenses": "BlueOak-1.0.0",
    "repository": "https://github.com/isaacs/minipass",
    "publisher": "Isaac Z. Schlueter",
    "email": "i@izs.me",
    "url": "http://blog.izs.me/",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/minipass",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/minipass/LICENSE.md"
  },
  "minizlib@3.1.0": {
    "licenses": "MIT",
    "repository": "https://github.com/isaacs/minizlib",
    "publisher": "Isaac Z. Schlueter",
    "email": "i@izs.me",
    "url": "http://blog.izs.me/",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/minizlib",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/minizlib/LICENSE"
  },
  "ms@2.1.3": {
    "licenses": "MIT",
    "repository": "https://github.com/vercel/ms",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/ms",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/ms/license.md"
  },
  "mute-stream@2.0.0": {
    "licenses": "ISC",
    "repository": "https://github.com/npm/mute-stream",
    "publisher": "GitHub Inc.",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/mute-stream",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/mute-stream/LICENSE"
  },
  "negotiator@1.0.0": {
    "licenses": "MIT",
    "repository": "https://github.com/jshttp/negotiator",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/negotiator",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/negotiator/LICENSE"
  },
  "ng2-processmanager@0.0.0": {
    "licenses": "UNLICENSED",
    "private": true,
    "path": "/home/dennis/Projects/angular2-processmanager",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/README.md"
  },
  "ngx-clipboard@16.0.0": {
    "licenses": "MIT",
    "repository": "https://github.com/maxisam/ngx-clipboard",
    "publisher": "Sam Lin",
    "email": "maxisam@gmail.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/ngx-clipboard",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/ngx-clipboard/README.md"
  },
  "ngx-color@7.3.3": {
    "licenses": "MIT",
    "repository": "https://github.com/scttcper/ngx-color",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/ngx-color",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/ngx-color/LICENSE"
  },
  "ngx-window-token@7.0.0": {
    "licenses": "MIT",
    "repository": "https://github.com/maxisam/ngx-window-token",
    "publisher": "Sam Lin",
    "email": "maxisam@gmail.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/ngx-window-token",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/ngx-window-token/README.md"
  },
  "node-gyp@12.2.0": {
    "licenses": "MIT",
    "repository": "https://github.com/nodejs/node-gyp",
    "publisher": "Nathan Rajlich",
    "email": "nathan@tootallnate.net",
    "url": "http://tootallnate.net",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/node-gyp",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/node-gyp/LICENSE"
  },
  "nopt@9.0.0": {
    "licenses": "ISC",
    "repository": "https://github.com/npm/nopt",
    "publisher": "GitHub Inc.",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/node-gyp/node_modules/nopt",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/node-gyp/node_modules/nopt/LICENSE"
  },
  "npm-bundled@5.0.0": {
    "licenses": "ISC",
    "repository": "https://github.com/npm/npm-bundled",
    "publisher": "GitHub Inc.",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/npm-bundled",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/npm-bundled/LICENSE"
  },
  "npm-install-checks@8.0.0": {
    "licenses": "BSD-2-Clause",
    "repository": "https://github.com/npm/npm-install-checks",
    "publisher": "GitHub Inc.",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/npm-install-checks",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/npm-install-checks/LICENSE"
  },
  "npm-normalize-package-bin@5.0.0": {
    "licenses": "ISC",
    "repository": "https://github.com/npm/npm-normalize-package-bin",
    "publisher": "GitHub Inc.",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/npm-normalize-package-bin",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/npm-normalize-package-bin/LICENSE"
  },
  "npm-package-arg@13.0.2": {
    "licenses": "ISC",
    "repository": "https://github.com/npm/npm-package-arg",
    "publisher": "GitHub Inc.",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/npm-package-arg",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/npm-package-arg/LICENSE"
  },
  "npm-packlist@10.0.4": {
    "licenses": "ISC",
    "repository": "https://github.com/npm/npm-packlist",
    "publisher": "GitHub Inc.",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/npm-packlist",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/npm-packlist/LICENSE"
  },
  "npm-pick-manifest@11.0.3": {
    "licenses": "ISC",
    "repository": "https://github.com/npm/npm-pick-manifest",
    "publisher": "GitHub Inc.",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/npm-pick-manifest",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/npm-pick-manifest/LICENSE.md"
  },
  "npm-registry-fetch@19.1.1": {
    "licenses": "ISC",
    "repository": "https://github.com/npm/npm-registry-fetch",
    "publisher": "GitHub Inc.",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/npm-registry-fetch",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/npm-registry-fetch/LICENSE.md"
  },
  "object-assign@4.1.1": {
    "licenses": "MIT",
    "repository": "https://github.com/sindresorhus/object-assign",
    "publisher": "Sindre Sorhus",
    "email": "sindresorhus@gmail.com",
    "url": "sindresorhus.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/object-assign",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/object-assign/license"
  },
  "object-inspect@1.13.4": {
    "licenses": "MIT",
    "repository": "https://github.com/inspect-js/object-inspect",
    "publisher": "James Halliday",
    "email": "mail@substack.net",
    "url": "http://substack.net",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/object-inspect",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/object-inspect/LICENSE"
  },
  "on-finished@2.4.1": {
    "licenses": "MIT",
    "repository": "https://github.com/jshttp/on-finished",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/on-finished",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/on-finished/LICENSE"
  },
  "once@1.4.0": {
    "licenses": "ISC",
    "repository": "https://github.com/isaacs/once",
    "publisher": "Isaac Z. Schlueter",
    "email": "i@izs.me",
    "url": "http://blog.izs.me/",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/once",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/once/LICENSE"
  },
  "onetime@7.0.0": {
    "licenses": "MIT",
    "repository": "https://github.com/sindresorhus/onetime",
    "publisher": "Sindre Sorhus",
    "email": "sindresorhus@gmail.com",
    "url": "https://sindresorhus.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/onetime",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/onetime/license"
  },
  "ora@9.3.0": {
    "licenses": "MIT",
    "repository": "https://github.com/sindresorhus/ora",
    "publisher": "Sindre Sorhus",
    "email": "sindresorhus@gmail.com",
    "url": "https://sindresorhus.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/ora",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/ora/license"
  },
  "p-map@7.0.4": {
    "licenses": "MIT",
    "repository": "https://github.com/sindresorhus/p-map",
    "publisher": "Sindre Sorhus",
    "email": "sindresorhus@gmail.com",
    "url": "https://sindresorhus.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/p-map",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/p-map/license"
  },
  "p-throttle@5.1.0": {
    "licenses": "MIT",
    "repository": "https://github.com/sindresorhus/p-throttle",
    "publisher": "Sindre Sorhus",
    "email": "sindresorhus@gmail.com",
    "url": "https://sindresorhus.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/p-throttle",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/p-throttle/license"
  },
  "pacote@21.3.1": {
    "licenses": "ISC",
    "repository": "https://github.com/npm/pacote",
    "publisher": "GitHub Inc.",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/pacote",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/pacote/LICENSE"
  },
  "parse5-html-rewriting-stream@8.0.0": {
    "licenses": "MIT",
    "repository": "https://github.com/inikulin/parse5",
    "publisher": "Ivan Nikulin",
    "email": "ifaaan@gmail.com",
    "url": "https://github.com/inikulin",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/parse5-html-rewriting-stream",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/parse5-html-rewriting-stream/LICENSE"
  },
  "parse5-sax-parser@8.0.0": {
    "licenses": "MIT",
    "repository": "https://github.com/inikulin/parse5",
    "publisher": "Ivan Nikulin",
    "email": "ifaaan@gmail.com",
    "url": "https://github.com/inikulin",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/parse5-sax-parser",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/parse5-sax-parser/LICENSE"
  },
  "parse5@8.0.0": {
    "licenses": "MIT",
    "repository": "https://github.com/inikulin/parse5",
    "publisher": "Ivan Nikulin",
    "email": "ifaaan@gmail.com",
    "url": "https://github.com/inikulin",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/parse5",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/parse5/LICENSE"
  },
  "parseurl@1.3.3": {
    "licenses": "MIT",
    "repository": "https://github.com/pillarjs/parseurl",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/parseurl",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/parseurl/LICENSE"
  },
  "path-key@3.1.1": {
    "licenses": "MIT",
    "repository": "https://github.com/sindresorhus/path-key",
    "publisher": "Sindre Sorhus",
    "email": "sindresorhus@gmail.com",
    "url": "sindresorhus.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/path-key",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/path-key/license"
  },
  "path-scurry@2.0.2": {
    "licenses": "BlueOak-1.0.0",
    "repository": "https://github.com/isaacs/path-scurry",
    "publisher": "Isaac Z. Schlueter",
    "email": "i@izs.me",
    "url": "https://blog.izs.me",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/path-scurry",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/path-scurry/LICENSE.md"
  },
  "path-to-regexp@8.3.0": {
    "licenses": "MIT",
    "repository": "https://github.com/pillarjs/path-to-regexp",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/path-to-regexp",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/path-to-regexp/LICENSE"
  },
  "picomatch@4.0.3": {
    "licenses": "MIT",
    "repository": "https://github.com/micromatch/picomatch",
    "publisher": "Jon Schlinkert",
    "url": "https://github.com/jonschlinkert",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/picomatch",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/picomatch/LICENSE"
  },
  "pkce-challenge@5.0.1": {
    "licenses": "MIT",
    "repository": "https://github.com/crouchcd/pkce-challenge",
    "publisher": "crouchcd",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/pkce-challenge",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/pkce-challenge/LICENSE"
  },
  "proc-log@6.1.0": {
    "licenses": "ISC",
    "repository": "https://github.com/npm/proc-log",
    "publisher": "GitHub Inc.",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/proc-log",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/proc-log/LICENSE"
  },
  "promise-retry@2.0.1": {
    "licenses": "MIT",
    "repository": "https://github.com/IndigoUnited/node-promise-retry",
    "publisher": "IndigoUnited",
    "email": "hello@indigounited.com",
    "url": "http://indigounited.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/promise-retry",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/promise-retry/LICENSE"
  },
  "proxy-addr@2.0.7": {
    "licenses": "MIT",
    "repository": "https://github.com/jshttp/proxy-addr",
    "publisher": "Douglas Christopher Wilson",
    "email": "doug@somethingdoug.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/proxy-addr",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/proxy-addr/LICENSE"
  },
  "qs@6.15.0": {
    "licenses": "BSD-3-Clause",
    "repository": "https://github.com/ljharb/qs",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/qs",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/qs/LICENSE.md"
  },
  "range-parser@1.2.1": {
    "licenses": "MIT",
    "repository": "https://github.com/jshttp/range-parser",
    "publisher": "TJ Holowaychuk",
    "email": "tj@vision-media.ca",
    "url": "http://tjholowaychuk.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/range-parser",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/range-parser/LICENSE"
  },
  "ranges-apply@7.1.3": {
    "licenses": "MIT",
    "repository": "https://github.com/codsen/codsen",
    "publisher": "Roy Revelt",
    "email": "roy@codsen.com",
    "url": "https://codsen.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/ranges-apply",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/ranges-apply/LICENSE"
  },
  "ranges-merge@9.1.3": {
    "licenses": "MIT",
    "repository": "https://github.com/codsen/codsen",
    "publisher": "Roy Revelt",
    "email": "roy@codsen.com",
    "url": "https://codsen.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/ranges-merge",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/ranges-merge/LICENSE"
  },
  "ranges-push@7.1.3": {
    "licenses": "MIT",
    "repository": "https://github.com/codsen/codsen",
    "publisher": "Roy Revelt",
    "email": "roy@codsen.com",
    "url": "https://codsen.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/ranges-push",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/ranges-push/LICENSE"
  },
  "ranges-sort@6.1.3": {
    "licenses": "MIT",
    "repository": "https://github.com/codsen/codsen",
    "publisher": "Roy Revelt",
    "email": "roy@codsen.com",
    "url": "https://codsen.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/ranges-sort",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/ranges-sort/LICENSE"
  },
  "raw-body@3.0.2": {
    "licenses": "MIT",
    "repository": "https://github.com/stream-utils/raw-body",
    "publisher": "Jonathan Ong",
    "email": "me@jongleberry.com",
    "url": "http://jongleberry.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/raw-body",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/raw-body/LICENSE"
  },
  "readdirp@5.0.0": {
    "licenses": "MIT",
    "repository": "https://github.com/paulmillr/readdirp",
    "publisher": "Thorsten Lorenz",
    "email": "thlorenz@gmx.de",
    "url": "thlorenz.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/readdirp",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/readdirp/LICENSE"
  },
  "require-from-string@2.0.2": {
    "licenses": "MIT",
    "repository": "https://github.com/floatdrop/require-from-string",
    "publisher": "Vsevolod Strukchinsky",
    "email": "floatdrop@gmail.com",
    "url": "github.com/floatdrop",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/require-from-string",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/require-from-string/license"
  },
  "restore-cursor@5.1.0": {
    "licenses": "MIT",
    "repository": "https://github.com/sindresorhus/restore-cursor",
    "publisher": "Sindre Sorhus",
    "email": "sindresorhus@gmail.com",
    "url": "https://sindresorhus.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/restore-cursor",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/restore-cursor/license"
  },
  "retry@0.12.0": {
    "licenses": "MIT",
    "repository": "https://github.com/tim-kos/node-retry",
    "publisher": "Tim Koschützki",
    "email": "tim@debuggable.com",
    "url": "http://debuggable.com/",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/promise-retry/node_modules/retry",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/promise-retry/node_modules/retry/License"
  },
  "retry@0.13.1": {
    "licenses": "MIT",
    "repository": "https://github.com/tim-kos/node-retry",
    "publisher": "Tim Koschützki",
    "email": "tim@debuggable.com",
    "url": "http://debuggable.com/",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/retry",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/retry/License"
  },
  "rfdc@1.4.1": {
    "licenses": "MIT",
    "repository": "https://github.com/davidmarkclements/rfdc",
    "publisher": "David Mark Clements",
    "email": "david.clements@nearform.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/rfdc",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/rfdc/LICENSE"
  },
  "router@2.2.0": {
    "licenses": "MIT",
    "repository": "https://github.com/pillarjs/router",
    "publisher": "Douglas Christopher Wilson",
    "email": "doug@somethingdoug.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/router",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/router/LICENSE"
  },
  "rxjs@7.8.2": {
    "licenses": "Apache-2.0",
    "repository": "https://github.com/reactivex/rxjs",
    "publisher": "Ben Lesh",
    "email": "ben@benlesh.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/rxjs",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/rxjs/LICENSE.txt"
  },
  "safer-buffer@2.1.2": {
    "licenses": "MIT",
    "repository": "https://github.com/ChALkeR/safer-buffer",
    "publisher": "Nikita Skovoroda",
    "email": "chalkerx@gmail.com",
    "url": "https://github.com/ChALkeR",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/safer-buffer",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/safer-buffer/LICENSE"
  },
  "screenfull@6.0.2": {
    "licenses": "MIT",
    "repository": "https://github.com/sindresorhus/screenfull",
    "publisher": "Sindre Sorhus",
    "email": "sindresorhus@gmail.com",
    "url": "sindresorhus.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/screenfull",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/screenfull/license"
  },
  "semver@7.7.4": {
    "licenses": "ISC",
    "repository": "https://github.com/npm/node-semver",
    "publisher": "GitHub Inc.",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/semver",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/semver/LICENSE"
  },
  "send@1.2.1": {
    "licenses": "MIT",
    "repository": "https://github.com/pillarjs/send",
    "publisher": "TJ Holowaychuk",
    "email": "tj@vision-media.ca",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/send",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/send/LICENSE"
  },
  "serve-static@2.2.1": {
    "licenses": "MIT",
    "repository": "https://github.com/expressjs/serve-static",
    "publisher": "Douglas Christopher Wilson",
    "email": "doug@somethingdoug.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/serve-static",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/serve-static/LICENSE"
  },
  "setprototypeof@1.2.0": {
    "licenses": "ISC",
    "repository": "https://github.com/wesleytodd/setprototypeof",
    "publisher": "Wes Todd",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/setprototypeof",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/setprototypeof/LICENSE"
  },
  "shebang-command@2.0.0": {
    "licenses": "MIT",
    "repository": "https://github.com/kevva/shebang-command",
    "publisher": "Kevin Mårtensson",
    "email": "kevinmartensson@gmail.com",
    "url": "github.com/kevva",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/shebang-command",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/shebang-command/license"
  },
  "shebang-regex@3.0.0": {
    "licenses": "MIT",
    "repository": "https://github.com/sindresorhus/shebang-regex",
    "publisher": "Sindre Sorhus",
    "email": "sindresorhus@gmail.com",
    "url": "sindresorhus.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/shebang-regex",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/shebang-regex/license"
  },
  "side-channel-list@1.0.0": {
    "licenses": "MIT",
    "repository": "https://github.com/ljharb/side-channel-list",
    "publisher": "Jordan Harband",
    "email": "ljharb@gmail.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/side-channel-list",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/side-channel-list/LICENSE"
  },
  "side-channel-map@1.0.1": {
    "licenses": "MIT",
    "repository": "https://github.com/ljharb/side-channel-map",
    "publisher": "Jordan Harband",
    "email": "ljharb@gmail.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/side-channel-map",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/side-channel-map/LICENSE"
  },
  "side-channel-weakmap@1.0.2": {
    "licenses": "MIT",
    "repository": "https://github.com/ljharb/side-channel-weakmap",
    "publisher": "Jordan Harband",
    "email": "ljharb@gmail.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/side-channel-weakmap",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/side-channel-weakmap/LICENSE"
  },
  "side-channel@1.1.0": {
    "licenses": "MIT",
    "repository": "https://github.com/ljharb/side-channel",
    "publisher": "Jordan Harband",
    "email": "ljharb@gmail.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/side-channel",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/side-channel/LICENSE"
  },
  "signal-exit@4.1.0": {
    "licenses": "ISC",
    "repository": "https://github.com/tapjs/signal-exit",
    "publisher": "Ben Coe",
    "email": "ben@npmjs.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/signal-exit",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/signal-exit/LICENSE.txt"
  },
  "sigstore@4.1.0": {
    "licenses": "Apache-2.0",
    "repository": "https://github.com/sigstore/sigstore-js",
    "publisher": "bdehamer@github.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/sigstore",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/sigstore/LICENSE"
  },
  "slice-ansi@7.1.2": {
    "licenses": "MIT",
    "repository": "https://github.com/chalk/slice-ansi",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/log-update/node_modules/slice-ansi",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/log-update/node_modules/slice-ansi/license"
  },
  "slice-ansi@8.0.0": {
    "licenses": "MIT",
    "repository": "https://github.com/chalk/slice-ansi",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/slice-ansi",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/slice-ansi/license"
  },
  "smart-buffer@4.2.0": {
    "licenses": "MIT",
    "repository": "https://github.com/JoshGlazebrook/smart-buffer",
    "publisher": "Josh Glazebrook",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/smart-buffer",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/smart-buffer/LICENSE"
  },
  "socks-proxy-agent@8.0.5": {
    "licenses": "MIT",
    "repository": "https://github.com/TooTallNate/proxy-agents",
    "publisher": "Nathan Rajlich",
    "email": "nathan@tootallnate.net",
    "url": "http://n8.io/",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/socks-proxy-agent",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/socks-proxy-agent/LICENSE"
  },
  "socks@2.8.7": {
    "licenses": "MIT",
    "repository": "https://github.com/JoshGlazebrook/socks",
    "publisher": "Josh Glazebrook",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/socks",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/socks/LICENSE"
  },
  "source-map@0.7.6": {
    "licenses": "BSD-3-Clause",
    "repository": "https://github.com/mozilla/source-map",
    "publisher": "Nick Fitzgerald",
    "email": "nfitzgerald@mozilla.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/source-map",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/source-map/LICENSE"
  },
  "spdx-exceptions@2.5.0": {
    "licenses": "CC-BY-3.0",
    "repository": "https://github.com/kemitchell/spdx-exceptions.json",
    "publisher": "The Linux Foundation",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/spdx-exceptions",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/spdx-exceptions/README.md"
  },
  "spdx-expression-parse@4.0.0": {
    "licenses": "MIT",
    "repository": "https://github.com/jslicense/spdx-expression-parse.js",
    "publisher": "Kyle E. Mitchell",
    "email": "kyle@kemitchell.com",
    "url": "https://kemitchell.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@npmcli/package-json/node_modules/spdx-expression-parse",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@npmcli/package-json/node_modules/spdx-expression-parse/LICENSE"
  },
  "spdx-license-ids@3.0.23": {
    "licenses": "CC0-1.0",
    "repository": "https://github.com/jslicense/spdx-license-ids",
    "publisher": "Shinnosuke Watanabe",
    "url": "https://github.com/shinnn",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/spdx-license-ids",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/spdx-license-ids/README.md"
  },
  "ssri@13.0.1": {
    "licenses": "ISC",
    "repository": "https://github.com/npm/ssri",
    "publisher": "GitHub Inc.",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/ssri",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/ssri/LICENSE.md"
  },
  "statuses@2.0.2": {
    "licenses": "MIT",
    "repository": "https://github.com/jshttp/statuses",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/statuses",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/statuses/LICENSE"
  },
  "stdin-discarder@0.3.1": {
    "licenses": "MIT",
    "repository": "https://github.com/sindresorhus/stdin-discarder",
    "publisher": "Sindre Sorhus",
    "email": "sindresorhus@gmail.com",
    "url": "https://sindresorhus.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/stdin-discarder",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/stdin-discarder/license"
  },
  "string-collapse-leading-whitespace@7.1.3": {
    "licenses": "MIT",
    "repository": "https://github.com/codsen/codsen",
    "publisher": "Roy Revelt",
    "email": "roy@codsen.com",
    "url": "https://codsen.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/string-collapse-leading-whitespace",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/string-collapse-leading-whitespace/LICENSE"
  },
  "string-left-right@6.1.3": {
    "licenses": "MIT",
    "repository": "https://github.com/codsen/codsen",
    "publisher": "Roy Revelt",
    "email": "roy@codsen.com",
    "url": "https://codsen.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/string-left-right",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/string-left-right/LICENSE"
  },
  "string-strip-html@13.5.3": {
    "licenses": "MIT",
    "repository": "https://github.com/codsen/codsen",
    "publisher": "Roy Revelt",
    "email": "roy@codsen.com",
    "url": "https://codsen.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/string-strip-html",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/string-strip-html/LICENSE"
  },
  "string-trim-spaces-only@5.1.3": {
    "licenses": "MIT",
    "repository": "https://github.com/codsen/codsen",
    "publisher": "Roy Revelt",
    "email": "roy@codsen.com",
    "url": "https://codsen.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/string-trim-spaces-only",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/string-trim-spaces-only/LICENSE"
  },
  "string-width@4.2.3": {
    "licenses": "MIT",
    "repository": "https://github.com/sindresorhus/string-width",
    "publisher": "Sindre Sorhus",
    "email": "sindresorhus@gmail.com",
    "url": "sindresorhus.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/wrap-ansi/node_modules/string-width",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/wrap-ansi/node_modules/string-width/license"
  },
  "string-width@7.2.0": {
    "licenses": "MIT",
    "repository": "https://github.com/sindresorhus/string-width",
    "publisher": "Sindre Sorhus",
    "email": "sindresorhus@gmail.com",
    "url": "https://sindresorhus.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/log-update/node_modules/string-width",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/log-update/node_modules/string-width/license"
  },
  "string-width@8.2.0": {
    "licenses": "MIT",
    "repository": "https://github.com/sindresorhus/string-width",
    "publisher": "Sindre Sorhus",
    "email": "sindresorhus@gmail.com",
    "url": "https://sindresorhus.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/string-width",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/string-width/license"
  },
  "strip-ansi@6.0.1": {
    "licenses": "MIT",
    "repository": "https://github.com/chalk/strip-ansi",
    "publisher": "Sindre Sorhus",
    "email": "sindresorhus@gmail.com",
    "url": "sindresorhus.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/wrap-ansi/node_modules/strip-ansi",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/wrap-ansi/node_modules/strip-ansi/license"
  },
  "strip-ansi@7.2.0": {
    "licenses": "MIT",
    "repository": "https://github.com/chalk/strip-ansi",
    "publisher": "Sindre Sorhus",
    "email": "sindresorhus@gmail.com",
    "url": "https://sindresorhus.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/strip-ansi",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/strip-ansi/license"
  },
  "tar@7.5.11": {
    "licenses": "BlueOak-1.0.0",
    "repository": "https://github.com/isaacs/node-tar",
    "publisher": "Isaac Z. Schlueter",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/tar",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/tar/LICENSE.md"
  },
  "tiny-invariant@1.3.3": {
    "licenses": "MIT",
    "repository": "https://github.com/alexreardon/tiny-invariant",
    "publisher": "Alex Reardon",
    "email": "alexreardon@gmail.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/tiny-invariant",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/tiny-invariant/LICENSE"
  },
  "tinyglobby@0.2.15": {
    "licenses": "MIT",
    "repository": "https://github.com/SuperchupuDev/tinyglobby",
    "publisher": "Superchupu",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/tinyglobby",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/tinyglobby/LICENSE"
  },
  "toidentifier@1.0.1": {
    "licenses": "MIT",
    "repository": "https://github.com/component/toidentifier",
    "publisher": "Douglas Christopher Wilson",
    "email": "doug@somethingdoug.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/toidentifier",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/toidentifier/LICENSE"
  },
  "trumbowyg@2.26.0": {
    "licenses": "MIT",
    "repository": "https://github.com/Alex-D/Trumbowyg",
    "publisher": "Alexandre Demode",
    "email": "contact@alex-d.fr",
    "url": "Alex-D",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/trumbowyg",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/trumbowyg/LICENSE"
  },
  "tslib@2.8.1": {
    "licenses": "0BSD",
    "repository": "https://github.com/Microsoft/tslib",
    "publisher": "Microsoft Corp.",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/tslib",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/tslib/LICENSE.txt"
  },
  "tuf-js@4.1.0": {
    "licenses": "MIT",
    "repository": "https://github.com/theupdateframework/tuf-js",
    "publisher": "bdehamer@github.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/tuf-js",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/tuf-js/LICENSE"
  },
  "type-is@2.0.1": {
    "licenses": "MIT",
    "repository": "https://github.com/jshttp/type-is",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/type-is",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/type-is/LICENSE"
  },
  "undici-types@5.26.5": {
    "licenses": "MIT",
    "repository": "https://github.com/nodejs/undici",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/undici-types",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/undici-types/README.md"
  },
  "unique-filename@5.0.0": {
    "licenses": "ISC",
    "repository": "https://github.com/npm/unique-filename",
    "publisher": "GitHub Inc.",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/unique-filename",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/unique-filename/LICENSE"
  },
  "unique-slug@6.0.0": {
    "licenses": "ISC",
    "repository": "https://github.com/npm/unique-slug",
    "publisher": "GitHub Inc.",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/unique-slug",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/unique-slug/LICENSE"
  },
  "unpipe@1.0.0": {
    "licenses": "MIT",
    "repository": "https://github.com/stream-utils/unpipe",
    "publisher": "Douglas Christopher Wilson",
    "email": "doug@somethingdoug.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/unpipe",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/unpipe/LICENSE"
  },
  "uuid@9.0.1": {
    "licenses": "MIT",
    "repository": "https://github.com/uuidjs/uuid",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/uuid",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/uuid/LICENSE.md"
  },
  "validate-npm-package-name@7.0.2": {
    "licenses": "ISC",
    "repository": "https://github.com/npm/validate-npm-package-name",
    "publisher": "GitHub Inc.",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/validate-npm-package-name",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/validate-npm-package-name/LICENSE"
  },
  "vary@1.1.2": {
    "licenses": "MIT",
    "repository": "https://github.com/jshttp/vary",
    "publisher": "Douglas Christopher Wilson",
    "email": "doug@somethingdoug.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/vary",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/vary/LICENSE"
  },
  "which@2.0.2": {
    "licenses": "ISC",
    "repository": "https://github.com/isaacs/node-which",
    "publisher": "Isaac Z. Schlueter",
    "email": "i@izs.me",
    "url": "http://blog.izs.me",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/which",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/which/LICENSE"
  },
  "which@6.0.1": {
    "licenses": "ISC",
    "repository": "https://github.com/npm/node-which",
    "publisher": "GitHub Inc.",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/@npmcli/promise-spawn/node_modules/which",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/@npmcli/promise-spawn/node_modules/which/LICENSE"
  },
  "wrap-ansi@6.2.0": {
    "licenses": "MIT",
    "repository": "https://github.com/chalk/wrap-ansi",
    "publisher": "Sindre Sorhus",
    "email": "sindresorhus@gmail.com",
    "url": "sindresorhus.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/wrap-ansi",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/wrap-ansi/license"
  },
  "wrap-ansi@9.0.2": {
    "licenses": "MIT",
    "repository": "https://github.com/chalk/wrap-ansi",
    "publisher": "Sindre Sorhus",
    "email": "sindresorhus@gmail.com",
    "url": "https://sindresorhus.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/log-update/node_modules/wrap-ansi",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/log-update/node_modules/wrap-ansi/license"
  },
  "wrappy@1.0.2": {
    "licenses": "ISC",
    "repository": "https://github.com/npm/wrappy",
    "publisher": "Isaac Z. Schlueter",
    "email": "i@izs.me",
    "url": "http://blog.izs.me/",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/wrappy",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/wrappy/LICENSE"
  },
  "y18n@5.0.8": {
    "licenses": "ISC",
    "repository": "https://github.com/yargs/y18n",
    "publisher": "Ben Coe",
    "email": "bencoe@gmail.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/y18n",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/y18n/LICENSE"
  },
  "yallist@4.0.0": {
    "licenses": "ISC",
    "repository": "https://github.com/isaacs/yallist",
    "publisher": "Isaac Z. Schlueter",
    "email": "i@izs.me",
    "url": "http://blog.izs.me/",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/minipass-flush/node_modules/yallist",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/minipass-flush/node_modules/yallist/LICENSE"
  },
  "yallist@5.0.0": {
    "licenses": "BlueOak-1.0.0",
    "repository": "https://github.com/isaacs/yallist",
    "publisher": "Isaac Z. Schlueter",
    "email": "i@izs.me",
    "url": "http://blog.izs.me/",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/tar/node_modules/yallist",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/tar/node_modules/yallist/LICENSE.md"
  },
  "yargs-parser@22.0.0": {
    "licenses": "ISC",
    "repository": "https://github.com/yargs/yargs-parser",
    "publisher": "Ben Coe",
    "email": "ben@npmjs.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/yargs-parser",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/yargs-parser/LICENSE.txt"
  },
  "yargs@18.0.0": {
    "licenses": "MIT",
    "repository": "https://github.com/yargs/yargs",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/yargs",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/yargs/LICENSE"
  },
  "yoctocolors-cjs@2.1.3": {
    "licenses": "MIT",
    "repository": "https://github.com/sindresorhus/yoctocolors",
    "publisher": "Sindre Sorhus",
    "email": "sindresorhus@gmail.com",
    "url": "https://sindresorhus.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/yoctocolors-cjs",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/yoctocolors-cjs/license"
  },
  "yoctocolors@2.1.2": {
    "licenses": "MIT",
    "repository": "https://github.com/sindresorhus/yoctocolors",
    "publisher": "Sindre Sorhus",
    "email": "sindresorhus@gmail.com",
    "url": "https://sindresorhus.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/yoctocolors",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/yoctocolors/license"
  },
  "zod-to-json-schema@3.25.1": {
    "licenses": "ISC",
    "repository": "https://github.com/StefanTerdell/zod-to-json-schema",
    "publisher": "Stefan Terdell",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/zod-to-json-schema",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/zod-to-json-schema/LICENSE"
  },
  "zod@4.3.6": {
    "licenses": "MIT",
    "repository": "https://github.com/colinhacks/zod",
    "publisher": "Colin McDonnell",
    "email": "zod@colinhacks.com",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/zod",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/zod/LICENSE"
  },
  "zone.js@0.15.1": {
    "licenses": "MIT",
    "repository": "https://github.com/angular/angular",
    "publisher": "Brian Ford",
    "path": "/home/dennis/Projects/angular2-processmanager/node_modules/zone.js",
    "licenseFile": "/home/dennis/Projects/angular2-processmanager/node_modules/zone.js/LICENSE"
  }
}

